console.log('top');

const topMv = document.querySelector('.ttl_box');

document.addEventListener("DOMContentLoaded", () => {

    const targets = document.querySelectorAll('.js-line-animate');

    const splitLines = (target) => {
        // 元のHTMLを保持
        const original = target.dataset.original || target.innerHTML;
        target.dataset.original = original;
        target.innerHTML = original;


        const nodes = Array.from(target.childNodes);
        const lines = [];
        let currentLine = [];

        nodes.forEach((node) => {
            if (node.nodeName === 'BR') {
                // ★ 表示されている br だけを改行扱い
                const style = window.getComputedStyle(node);
                if (style.display !== 'none') {
                    lines.push(currentLine);
                    currentLine = [];
                }
            } else {
                currentLine.push(node);
            }
        });
        lines.push(currentLine);

        target.innerHTML = '';

        lines.forEach((lineNodes) => {
            if (!lineNodes.length) return;

            const line = document.createElement('span');
            line.className = 'line';

            const inner = document.createElement('span');
            lineNodes.forEach((n) => inner.appendChild(n));

            line.appendChild(inner);
            target.appendChild(line);
        });
    };

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;

                const lines = entry.target.querySelectorAll('.line > span');
                lines.forEach((line, i) => {
                    line.style.transitionDelay = `${i * 0.15}s`;
                });

                entry.target.classList.add('is-show');
                observer.unobserve(entry.target);
            });
        },
        { threshold: 0.2 }
    );

    const init = () => {
        targets.forEach((target) => {
            target.classList.remove('is-show');
            splitLines(target);
            observer.observe(target);
        });
    };

    init();

    // --------------------------------------------------
    // 1. トップ動画制御（変更なし）
    // --------------------------------------------------
    const controlBtn = document.getElementById("controlBtn");
    const video = document.querySelector(".mv video");
    const videoText = document.querySelector(".mv_video_text");
    const image = document.querySelector(".mv .mv_end_img");

    let isTransitioning = false;

    if (controlBtn && video && image) {
        controlBtn.textContent = "Skip";
        image.style.opacity = 0;
        image.style.display = "none";

        video.addEventListener("ended", () => {
            if (!isTransitioning) skipVideo();
        });

        controlBtn.addEventListener("click", () => {
            if (isTransitioning) return;
            if (video.paused || video.classList.contains("is-hidden")) {
                replayVideo();
            } else {
                skipVideo();
            }
        });

        function skipVideo() {
            isTransitioning = true;
            fadeOut(video, () => {
                video.pause();
                video.classList.add("is-hidden");

                video.style.display = "none";
                fadeIn(image, () => {
                    image.classList.add("is-active");
                    controlBtn.textContent = "Replay";
                    isTransitioning = false;
                });
            });
        }

        function replayVideo() {
            isTransitioning = true;
            fadeOut(image, () => {
                image.classList.remove("is-active");
                image.style.display = "none";
                video.currentTime = 0;
                video.classList.remove("is-hidden");
                video.style.display = "block";
                fadeIn(video, () => {
                    video.play();
                    controlBtn.textContent = "Skip";
                    isTransitioning = false;
                });
            });
        }

        function fadeOut(el, callback) {
            el.style.transition = "opacity 0.8s ease";
            el.style.opacity = 1;
            requestAnimationFrame(() => {
                el.style.opacity = 0;
                setTimeout(() => {
                    if (typeof callback === "function") callback();
                }, 800);
            });
        }

        function fadeIn(el, callback) {
            el.style.transition = "opacity 0.8s ease";
            el.style.display = "block";
            el.style.opacity = 0;
            requestAnimationFrame(() => {
                el.style.opacity = 1;
                setTimeout(() => {
                    if (typeof callback === "function") callback();
                }, 800);
            });
        }
    }


    // --------------------------------------------------
    // 2. Lenis スムーススクロール初期化（同期の修正）
    // --------------------------------------------------
    const lenis = new Lenis({
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        smoothWheel: true,
    });

    // Lenis と GSAP の連携設定を最適化
    lenis.on("scroll", ScrollTrigger.update);

    gsap.ticker.add((time) => {
        lenis.raf(time * 1000);
    });
    gsap.ticker.lagSmoothing(0, 0);

    // --------------------------------------------------
    // 3. GSAP スクロールアニメーション制御
    // --------------------------------------------------
    gsap.registerPlugin(ScrollTrigger);

    const sections = document.querySelectorAll('.link-section');
    const bgCurrent = document.querySelector('.bg-current');
    const bgNext = document.querySelector('.bg-next');

    // 画像の事前読み込み
    sections.forEach(section => {
        const url = section.getAttribute('data-bg');
        if (url) {
            const img = new Image();
            img.src = url;
        }
    });

    let activeBgUrl = '';
    let bgTween = null;

    // 背景画像のクロスフェード切り替え（安全設計）
    function switchBackgroundImage(newBgUrl) {
        if (!newBgUrl || newBgUrl === activeBgUrl) return;

        activeBgUrl = newBgUrl;

        if (bgTween) bgTween.kill();

        bgNext.style.backgroundImage = `url(${newBgUrl})`;

        bgTween = gsap.to(bgNext, {
            opacity: 1,
            duration: 0.6,
            ease: "power2.out",
            onComplete: () => {
                bgCurrent.style.backgroundImage = `url(${newBgUrl})`;
                gsap.set(bgNext, { opacity: 0 });
                bgTween = null;
            }
        });
    }

    // ★ 初期状態：ページ読み込み時に「セクション1」の背景画像をセットしておく
    if (sections.length > 0) {
        const firstBg = sections[0].getAttribute('data-bg');
        if (firstBg) {
            activeBgUrl = firstBg;
            bgCurrent.style.backgroundImage = `url(${firstBg})`;
        }
    }

    // 各カードのアニメーション設定
    sections.forEach((section, index) => {
        const card = section.querySelector('.link_wrap');
        const isLast = index === sections.length - 1;

        // 現在の背景画像と、カードが広がりきった時に切り替える「次の背景画像」を取得
        const currentBg = section.getAttribute('data-bg');
        const nextBg = !isLast ? sections[index + 1].getAttribute('data-bg') : currentBg;

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: section,
                start: "top bottom",
                end: isLast ? "center center" : "bottom top",
                scrub: 0.5,
            }
        });

        if (isLast) {
            // --------------------------------------------------
            // 最後のセクション（セクション3）: 拡大して背景切り替え
            // --------------------------------------------------
            tl.fromTo(card,
                { scale: 0.7, force3D: true },
                { scale: 1.0, ease: "power1.out", duration: 1 }
            )
                .call(() => {
                    // スクロール方向に応じて背景を切り替え
                    const isScrollingDown = tl.scrollTrigger.direction > 0;
                    switchBackgroundImage(isScrollingDown ? currentBg : currentBg);
                });

        } else {
            // --------------------------------------------------
            // 通常のセクション（1, 2）: 
            // カード拡大(1.0) ➔ ★ここで次のセクションの背景(nextBg)へ切り替え ➔ 縮小(0.7)
            // --------------------------------------------------
            tl.fromTo(card,
                { scale: 0.7, force3D: true },
                { scale: 1.0, ease: "power1.out", duration: 1 }
            )
                // カードが全画面に広がりきったタイミングで発火
                .call(() => {
                    const isScrollingDown = tl.scrollTrigger.direction > 0;
                    // 下スクロール時は「次の背景(nextBg)」、上スクロール戻り時は「現在の背景(currentBg)」
                    switchBackgroundImage(isScrollingDown ? nextBg : currentBg);
                })
                .to(card,
                    { scale: 0.7, ease: "power1.in", duration: 1 }
                );
        }
    });

    // 画面の崩れ防止のためにリフレッシュ
    ScrollTrigger.refresh();
});

